import React, { useEffect, useState } from "react";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import IconButton from "@material-ui/core/IconButton";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { withStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import { useTranslation } from "react-i18next";
import { activeAutom } from "../../../recoil-store/recoil-state";
import { useRecoilState } from "recoil";


const BootstrapInput = withStyles((theme) => ({
    root: {
        "label + &": {
            marginTop: theme.spacing(3),
        },
        input: {
            position: 'relative',
            paddingLeft: 5,
            // border: "0.5px solid #D5D5D5"
            // Use the system font instead of the default Roboto font.

        },
    }
}))(InputBase);

function VariablePicker({
    action,
    inputName,
    variables,
    setOpenVariable,
    isRequired,
    filter,
    remove,
    condition,
    inputIndex,
    variableRender,
    showVariablePicker,
    isNull = false,
    inputName2,
    index,
    inputName3,
    system,
    disabled,
    setField,
    styles,
    isOutput
}) {
    const [filteredVariables, setFilteredVariables] = useState([]);
    const [variable, setVariable] = useState('');
    const [automDetail, setAutomDetail] = useRecoilState(activeAutom);
    let lsInputName = localStorage.getItem("inputName");
    let variableName = localStorage.getItem("variablename");
    const { t } = useTranslation();
    useEffect(() => {
        if (inputName) {
            localStorage.removeItem("inputName");
            if (!action.fields[inputName]) {
                action.fields[inputName] = { value: '', type: 'VARIABLEPICKER', isRequired, variableType: '' };
            } else {
                if (!isNull) {
                    if (variableName !== null && lsInputName === inputName) {
                        let filterType = filterVariablesTypes(variableName);
                        action.fields[inputName].variableType = (filterType !== null && filterType !== undefined) ? filterType[0].type : '';
                        setVariable(variableName)
                        action.fields[inputName].value = variableName;
                    } else {
                        setVariable(action.fields[inputName].value);
                    }
                    localStorage.removeItem("variablename");

                } else {
                    if (variableName !== null && lsInputName === inputName) {
                        let filterType = filterVariablesTypes(variableName);
                        action.fields[inputName].variableType = (filterType !== null && filterType !== undefined) ? filterType[0].type : '';
                        setVariable(variableName)
                        action.fields[inputName].value = variableName;
                    } else {
                        if (action.fields[inputName2]) {
                            setVariable(action.fields[inputName2].value[index][inputName3]);
                        } else {
                            setVariable("");
                        }
                    }
                    localStorage.removeItem("variablename");

                }
            }
        } else if (inputIndex >= 0 && action) {
            if (!action[inputIndex]) {
                action[inputIndex] = { value: '', type: 'VARIABLEPICKER', isRequired, variableType: '' };
            } else {
                if (!isNull) {
                    if (variableName !== null && lsInputName === inputName) {
                        let filterType = filterVariablesTypes(variableName);
                        action[inputIndex].variableType = (filterType !== null && filterType !== undefined) ? filterType[0].type : '';
                        setVariable(variableName)
                        action[inputIndex].value = variableName;
                    } else {
                        setVariable(action[inputIndex].value);
                    }
                    localStorage.removeItem("variablename");

                } else {
                    if (variableName !== null && lsInputName === inputName) {
                        let filterType = filterVariablesTypes(variableName);
                        action[inputIndex].variableType = (filterType !== null && filterType !== undefined) ? filterType[0].type : '';
                        setVariable(variableName)
                        action[inputIndex].value = variableName;
                    } else {
                        if (action.fields[inputName2]) {
                            setVariable(action.fields[inputName2].value[index][inputName3]);
                        } else {
                            setVariable("");
                        }
                    }
                    localStorage.removeItem("variablename");
                }
            }
        }
        if (filter) {
            setFilteredVariables(Object.keys(variables).length > 0 ? variables.filter((x) => x.type === filter) : []);
        } else if (remove) {
            setFilteredVariables(Object.keys(variables).length > 0 ? variables?.filter((x) => !remove.includes(x.type)) : []);
        } else if (system) {
            setFilteredVariables(Object.keys(variables).length > 0 ? variables?.filter(x => x.system_variable !== 1) : []);
        } else {
            setFilteredVariables(variables);
        }
    }, [action, variables, filter]);

    function filterVariablesTypes(value) {
        return variables && variables.filter(v => v.name.toLowerCase() === value.toLowerCase())
    }

    const handleSetChange = (event) => {
        //filtered variables
        let filterType = filterVariablesTypes(event.target.value);
        setVariable(event.target.value);
        if (inputName) {
            action.fields[inputName].variableType = (filterType[0] !== null && filterType[0] !== undefined) ? filterType[0].type : '';
            action.fields[inputName].value = event.target.value;
            if (setField) {
                setField(inputName, { value: event.target.value, variableType: action.fields[inputName].variableType });
            }
        } else if (inputIndex >= 0) {
            action[inputIndex].variableType = filterType[0] !== undefined ? filterType[0].type : '';
            action[inputIndex].value = event.target.value;
        }
        if (isOutput) {
            let copyItems = JSON.parse(JSON.stringify(automDetail.items))

            findAndUpdateItem(copyItems)
            setAutomDetail({
                ...automDetail,
                items: copyItems
            })
        }
    }

    const findAndUpdateItem = (items) => {
        items.forEach(item => {
            if (item.item_id === action.item_id) {
                item.fields = JSON.parse(JSON.stringify(action.fields))
                return;
            } else if (item.children) {
                findAndUpdateItem(item.children)
            }
        })
    }

    const handleOpen = () => {
        setOpenVariable(true);
        localStorage.setItem("inputName", inputName);
    }

    return (
        <>
            {isRequired === true &&
                <small style={{ color: '#D75E5E' }}>&nbsp; {t('FLOW-MESSAGES.LIBRARY.GENERAL.REQUIRED')}</small>}
            <div style={{ display: 'flex' }}>
                <FormControl variant="outlined" fullWidth style={{ width: "90%" }} disabled={disabled}>
                    <Select
                        style={{ borderRadius: 2, border: "0.5px solid #D5D5D5", height: 34, ...styles }}
                        variant="outlined" value={variable} onChange={handleSetChange}
                        input={(variable || !isRequired) ? null : <BootstrapInput />}>
                        <MenuItem style={{ fontSize: 12 }} value=""><em>None</em></MenuItem>
                        {filteredVariables?.length > 0 && JSON.stringify(filteredVariables[0]) !== '{}' ? filteredVariables.map((item, itemI) =>
                            <MenuItem style={{ fontSize: 12 }} key={itemI}
                                value={condition ? ('##' + item.name + '##') : item.name}>{item.display_name ? item.display_name : item.name}</MenuItem>
                        ) :
                            <span />
                            // <MenuItem button onClick={()=>handleOpen()} value="">{t('CONTENT.AUTOMS-LIST.ADD-NEW-VARIABLES')}</MenuItem>
                        }
                    </Select>
                </FormControl>
                {(showVariablePicker === undefined || showVariablePicker) &&
                    <IconButton disabled={disabled} style={{ padding: 0 }} onClick={() => handleOpen()}>
                        <AddCircleOutlineIcon style={{ paddingLeft: 5, color: "#8C90A2" }} />
                    </IconButton>}
            </div>
        </>
    )
}

export default VariablePicker;
